/**
 * 语义化版本比较工具
 */

/**
 * @param {string} v1 - 版本A, 如 "1.2.3"
 * @param {string} v2 - 版本B, 如 "1.2.4"
 * @returns {number} 1: v1>v2, 0: v1===v2, -1: v1<v2
 */
export function compareVersion(v1, v2) {
  if (!v1 || !v2) return 0;

  const parts1 = v1.replace(/^[vV]/, '').split('.').map(Number);
  const parts2 = v2.replace(/^[vV]/, '').split('.').map(Number);

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const num1 = parts1[i] || 0;
    const num2 = parts2[i] || 0;
    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }
  return 0;
}

/**
 * 校验版本号格式是否合法
 * @param {string} version
 * @returns {boolean}
 */
export function isValidVersion(version) {
  if (!version) return false;
  return /^\d+\.\d+\.\d+$/.test(version.replace(/^[vV]/, ''));
}
